<template>
  <Navbar></Navbar>
  <slot></slot>
  <Footer></Footer>
</template>
